import angular, {IIntervalService, IPromise} from "angular";
import moment from "moment";
import _ from "lodash";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {InterWindowBus} from "../../../../../felles/tjenester/InterWindowBus";

const debug:Debugger = require('debug')('LoggUtEtterInaktivitetAdvarselKontroller');

require('./loggUtEtterInaktivitetAdvarsel.scss');

export class LoggUtEtterInaktivitetAdvarselKontroller implements MdDialogController {

    /**
     * Viser modal dialog med varsel om at bruker snart blir logget ut pga inaktivitet.
     * Returnert promise resolver dersom bruker klikker på "logg ut" eller dialogen timer ut,
     * reject dersom bruker klikker på "fortsett"
     *
     * @param inaktivitetVarighet hvor lenge bruker har vært inaktiv
     * @param timeout hvor lang tid det skal gå før dialog timer ut
     * @param $mdDialog material dialog tjeneste
     */
    static visLoggUtEtterInaktivitetAdvarsel(inaktivitetVarighet:moment.Duration, timeout:moment.Duration, $mdDialog: angular.material.IDialogService):IPromise<l.Tokenvarighet>{
        return $mdDialog.show({
            template: require('./loggUtEtterInaktivitetAdvarsel.html'),
            locals: {
                inaktivitet: inaktivitetVarighet,
                timeout: timeout
            },
            controller: [regNavn.md.$mdDialog, regNavn.ng.$interval, InterWindowBus.regNavn, LoggUtEtterInaktivitetAdvarselKontroller],
            controllerAs:'$ctrl',
            bindToController: true,
            multiple:true //tillater at vi viser denne dialogen uten av eventuelle eksisterende dialoger lukkes
        });
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private $interval: IIntervalService,
                private interWindowBus:InterWindowBus) {
    }

    private static loggUtAdvarselDialogFortsettIWBHendelse = 'LoggUtEtterInaktivitetAdvarselKontroller_fortsett';

    forbliInnlogget = false;

    private inaktivitet:moment.Duration; //settes via locals
    private timeout:moment.Duration; //settes via locals

    /** dato/klokkeslett når sesjonen timer ut*/
    private timeoutTidspunkt:moment.Moment;

    /** timeout i sekunder */
    private timeoutSekunder:number;
    /** antall sekunder igjen */
    private restSekunder:number;
    /** interval som blir sørger for å telle ned 'rest' hvert sekund */
    private ngInterval;

    private iwbHendelseslytterAvregistrering:Function;

    inaktivitetMinutter(){
        return Math.floor(this.inaktivitet.asMinutes());
    }

    /** prosent av nedtelling, mellom 0 og 100. */
    somProsent(){
        return (this.restSekunder / this.timeoutSekunder) * 100;
    }

    somMinutterOgSekunder(){
        const minutter = Math.floor(this.restSekunder / 60);
        const sekunder = _.padStart((this.restSekunder % 60).toString(), 2, '0');
        return `${minutter}:${sekunder}`;
    }

    loggUt(){
        this.$interval.cancel(this.ngInterval);
        this.$mdDialog.cancel();
    }

    fortsett(signaliserTilØvrigeVinduer = true) {
        debug("fortsett", {signaliserTilØvrigeVinduer:signaliserTilØvrigeVinduer})
        this.$interval.cancel(this.ngInterval);
        this.$mdDialog.hide(this.forbliInnlogget ? l.Tokenvarighet.medium : l.Tokenvarighet.kort);
        if (signaliserTilØvrigeVinduer) this.interWindowBus.signaliser(LoggUtEtterInaktivitetAdvarselKontroller.loggUtAdvarselDialogFortsettIWBHendelse);
    }

    $onInit() {
        this.restSekunder = this.timeoutSekunder = Math.floor(this.timeout.asSeconds());
        this.ngInterval = this.$interval(() => this.dekrement(), 1000);
        this.timeoutTidspunkt = moment().add(this.timeout);
        this.iwbHendelseslytterAvregistrering = this.interWindowBus.ved(LoggUtEtterInaktivitetAdvarselKontroller.loggUtAdvarselDialogFortsettIWBHendelse, () => this.fortsett(false));
        debug('constructor', this.timeoutTidspunkt.toDate(), this.restSekunder);
    }

    $onDestroy(): void {
        this.iwbHendelseslytterAvregistrering();
    }

    private dekrement(){
        this.restSekunder--;
        //tilfelle $interval ikke blir kalt hvert sekund sjekker vi her mot forventet timeoutTidspunkt og justerer dersom for stort avvik
        const sekunderTilTimeout = this.timeoutTidspunkt.diff(moment(), 'seconds');
        if (Math.abs(sekunderTilTimeout - this.restSekunder) > 3) this.restSekunder = sekunderTilTimeout;
        if (this.restSekunder < 0) this.loggUt();
    }
}
